import { GameModeHandler } from './GameModeHandler';
import BallManager from '../ballManager';
import { RoomState } from '../../shared/sharedTypes';

export abstract class BaseGameMode implements GameModeHandler {
    protected ballManager: BallManager;
    protected roomState: RoomState;

    constructor(ballManager: BallManager, roomState: RoomState) {
        this.ballManager = ballManager;
        this.roomState = roomState;
    }

    init(): void {
        console.log(`Initializing Game Mode: ${this.getModeName()}`);
    }

    update(dt: number): void {
        // Common update logic (timers, etc.) can go here
    }

    destroy(): void {
        // Cleanup
    }

    onBallStrike(position: {x: number, y: number}, power: number, angle: number): void {
        // Default strike behavior (can be overridden)
    }

    onBallCollision(target: any): void {
        // Default collision behavior
    }

    onLevelStart(): void {
        // Default level start
    }

    onRightClick(worldX: number, worldY: number): void {
        // Default: no action on right-click
    }

    getPhysicsSettings(): any {
        return {
            gravity: { x: 0, y: 1 },
            airFriction: 0.01
        };
    }

    getStrikeMultiplier(): number {
        return 1.0;
    }

    shouldGeneratePlatforms(): boolean {
        return true;
    }

    getPlatformGenerationSettings(): any {
        return {};
    }

    getLevelHeight(): number | undefined {
        // Default: use standard height
        return undefined;
    }

    hasPersistentUpgrades(): boolean {
        return false;
    }

    hasInterstitialPowerups(): boolean {
        // Default to true only for GolfUP, but logic can be refined here
        return this.roomState.roomSettings?.gameMode === 'golfUP';
    }

    hasLevelUps(): boolean {
         // Usually correlates with interstitial powerups or persistent upgrades
         return this.hasInterstitialPowerups() || this.hasPersistentUpgrades();
    }

    hasCombos(): boolean {
        // Default to true for most modes, override to false for specific modes like RegularGolf
        return this.roomState.roomSettings?.gameMode !== 'regularGolf';
    }

    hasDoubleJump(): boolean {
        // Default to true, override to false for Regular Golf
        return this.roomState.roomSettings?.gameMode !== 'regularGolf';
    }

    hasRounds(): boolean {
        return true;
    }

    hasTimer(): boolean {
        return true;
    }

    abstract getModeName(): string;

    getVisibleUIElements(): string[] {
        // Default: show nothing extra (Time is handled separately usually)
        // But for Regular Golf (fallback), we might want 'par'
        // If this is strictly "Base", we can return empty and let subclasses decide.
        // However, to support the fallback "Classic/RegularGolf" behavior without a dedicated class yet:
        if (this.roomState.roomSettings?.gameMode === 'regularGolf') {
            return ['par'];
        }
        return [];
    }

    shouldShowPlayerLabels(): boolean {
        return true;
    }

    shouldShowScorePopups(): boolean {
        // Default to showing score popups only if combos are enabled
        return this.hasCombos();
    }
}

